<div class="grid grid-cols-24 my-12 md:my-20">
  <div class="col-start-2 col-span-22 md:col-start-3 md:col-span-20 lg:col-start-5 lg:col-span-16">
    <h1 class="text-center justify-center text-gray-900 text-4xl font-extrabold font-['Inter'] leading-10">
      Comece grátis e encontre oportunidades com mais confiança
    </h1>
    <div class="mt-4">
      <div class="mx-auto max-w-3xl">
        <p class="text-center text-gray-500 text-xl font-normal font-['Inter'] leading-relaxed">
          Teste a Casato Brasil por 7 dias e descubra imóveis de leilão com análises, estimativas e informações organizadas para ajudar na sua decisão.
        </p>
        <p class="mt-4 text-center text-gray-500 text-base font-normal font-['Inter'] leading-relaxed">
          Após os 7 dias, o plano escolhido será ativado automaticamente. Você pode cancelar a qualquer momento antes do término do período grátis diretamente na sua conta — sem burocracia, sem precisar falar com ninguém. Transparência faz parte da Casato Brasil.
        </p>
      </div>
    </div>

    <div class="grid grid-cols-12 mt-10 gap-5">
      <div class="col-span-12">
        <app-plans-template [isLoading]="isLoading" (planSelected)="onPlanSelected($event)"></app-plans-template>
      </div>
    </div>
  </div>
</div>

<app-why-choose-template></app-why-choose-template>

<app-trial-template (ctaSelected)="onTrialSelected()"></app-trial-template>
